import {ClickerGCSEngine} from '../../ClickerGame.types';
import {pointsEmitterConfig} from './PointsEmitter.config';
import {ContainerChild, Point, Sprite, Text, Texture} from 'pixi.js';

import {BaseComponent, IGameWorld} from '@specials/gcs-engine';
import {ParticleEmitter, SpawnShapeType} from '@specials/particle-emitter';

import {EmittersContainer} from '../EmittersContainer/EmittersContainer';
import {EmittersContainerViewComponent} from '../EmittersContainer/EmittersContainerViewComponent';

export class PointsEmitterPoolComponent extends BaseComponent {
  private container?: EmittersContainerViewComponent;
  private text: Text;
  private emitter: ParticleEmitter;
  private texturePool: Record<number, Texture>;

  constructor(private readonly gcsEngine: ClickerGCSEngine) {
    super();
  }

  public onAddToWorld(world: IGameWorld): void {
    this.texturePool = {};
    this.text = this.createText();
    this.gcsEngine.renderer.container.addChild(this.text);
    this.container = world.getGameObject(EmittersContainer)?.getComponent(EmittersContainerViewComponent);
    this.emitter = this.createEmitter();
  }

  public spawnPoints(points: number, pos: Point): void {
    this.emitter.config.spawnShape = {
      shape: {
        type: SpawnShapeType.Point,
        x: pos.x,
        y: pos.y,
      },
    };
    this.text.text = '+' + points;

    this.emitter.config.view = () => this.createSprite(this.getTexture(points));
    this.emitter.emitOnce();
  }

  private createEmitter(): ParticleEmitter {
    if (!this.container) throw new Error('app is not defined');

    const emitter = new ParticleEmitter<ContainerChild>(
      this.container.view,
      () => this.createSprite(this.getTexture(1)),
      {
        emitterConfig: {autoStart: false},
        particleConfig: pointsEmitterConfig(),
      },
    );

    return emitter;
  }

  private getTexture(points: number): Texture {
    const texture: Texture | undefined = this.texturePool[points];
    if (!texture) {
      const app = this.gcsEngine.renderer.renderer.app;
      const texture = app!.renderer.generateTexture(this.text);
      this.texturePool[points] = texture;
      return texture;
    }

    return texture;
  }

  private createSprite = (texture: Texture): Sprite => {
    const sprite = new Sprite(texture);
    sprite.anchor.set(0.5);
    return sprite;
  };

  private createText(): Text {
    const text = new Text({
      text: '+1',
      style: {
        fontSize: 42,
        fill: '#3BE1FF',
        fontFamily: 'Tt Supermolot Neue Medium',
      },
    });
    // text.x = -1000;
    // text.y = -1000;

    return text;
  }
}
